// extracted by mini-css-extract-plugin
export default {"asSeenOn":"as-seen-on-module__asSeenOn__iFyqk","templateTwo":"as-seen-on-module__templateTwo__dlTJe"};